/**
 * 第三方登录态带货相关
 *
 * 依赖zoneRoleSelector
 * setZoneSelectorZoneInfo
 */

import * as url from "@utils/url"
import * as reportDict from "@constants/report-dictonary"
import { mapActions, mapGetters } from "vuex"
import * as yodajsApi from "@api/yodajs"
// import * as kuaiApi from "@api/kwai"
import * as mqqApi from "@api/mqq"
import * as enums from "@store/enums"
import { CmallQueryApi } from "@api/cmallQuery"
import { WX_APPID } from "@constants/langs"
import { session_third } from "@tencent/midas-util"
import { checkSessionType, getOpenlink } from "@api/user"
import { getShareUrl } from "@utils/helper"
import { setUserPrivacy } from "../../business/auth"

export default {
  beforeRouteLeave(to, from, next) {
    this.promptInstance?.hide()
    this.promptInstance = null
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 判断是否直接进入页面
      if (!vm.isStraightUrl) {
        if (from.path === "/" && from.matched && from.matched.length === 0) {
          vm.isStraightUrl = true
        } else {
          vm.isStraightUrl = false
        }
      }
    })
  },
  data() {
    return {
      promptInstance: null,
      APP_NAME: {
        Kwai: "快手",
        ksNebula: "快手极速版",
        huya: "虎牙",
        douyu: "斗鱼",
        other: "",
        isStraightUrl: false
      },
      cmallQueryObj: null,
      // 登录态是否有效 || 第三方登录态绑定账号登录态失效
      invalidSession: false,
      userIsBindAccount: false
    }
  },
  computed: {
    ...mapGetters(["userAgent", "loginState", "pfSource", "pf", "currentItem", "sandbox", "sessionObj"]),
    currentOfferId() {
      return url.getParam("biz_appid") || this.currentItem?.ams?.offerid
    },
    thirdLoginState() {
      return {
        openid: url.getParam("openid"),
        openkey: url.getParam("openkey"),
        sessionId: url.getParam("sessionid"),
        sessionType: url.getParam("sessiontype")
      }
    },
    thirdSessionObj() {
      let sessionObj
      if (this.thirdLoginState.sessionType == "st_local_third_party") {
        sessionObj = new session_third({
          openid: this.thirdLoginState.openid,
          openkey: this.thirdLoginState.openkey
        })
      } else if (this.thirdLoginState.sessionType == "st_third_party") {
        sessionObj = new session_third({
          openid: this.thirdLoginState.openid,
          thirdToken: this.thirdLoginState.openkey
        })
      }
      return sessionObj
    },
    // 判断是否是第三方登录态
    checkThirdSession() {
      return checkSessionType({ sessionObj: this.sessionObj }) == "third"
    },
    // 判断用户是否绑定微信或QQ账号
    checkUserIsBindAccount() {
      if (this.checkThirdSession) {
        return this.userIsBindAccount
      } else {
        return true
      }
    },
    isPcGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.PC_GAME
    },
    // 是否是手游专区
    isMobileGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.MOBILE_GAME
    },
    AppName() {
      let ua = this.userAgent
      if (ua.ksNebula) return this.APP_NAME["ksNebula"]
      if (ua.Kwai) return this.APP_NAME["Kwai"]
      if (ua.huya) return this.APP_NAME["huya"]
      if (ua.douyu) return this.APP_NAME["douyu"]
      return this.APP_NAME["other"]
    }
  },
  methods: {
    ...mapActions(["reportUserAction", "setProvideAccountType", "setLoginState", "clearGameCoinBalance"]),
    // 更新第三方登录态是否失效状态
    updateInvalidSession(bool) {
      this.invalidSession = bool
    },
    initCmallQueryObj() {
      // 查询和清空第三方登录态绑定的微信QQ登录态，所以主登录态一定为第三方登录态
      if (this.cmallQueryObj) {
        return this.cmallQueryObj
      } else {
        return new CmallQueryApi({
          pf: `${this.pfSource}-${this.pf}-${this.userAgent.iOS ? "iap" : "android"}`,
          sandbox: this.sandbox,
          sessionObj: this.thirdSessionObj,
          offerId: this.currentOfferId,
          channel_id: url.getParam("tx_chan_type")
        })
      }
    },

    /**
     * 弹出选择账号的弹窗 || 提示用户先绑定账号
     * @param {*} show
     */
    showAccountSelector(show = true) {
      if (this.userAgent.inThirdApp) {
        if (show) {
          this.$SelectAccountPrompt({
            selectAccount: this.selectAccount
          }).show()

          this.reportUserAction({
            iformat: reportDict.PAGE_VIEW.DETAIL_OUTER_CHANGE_ACCOUNT
          })
        } else {
          this.$SelectAccountPrompt({
            selectAccount: this.selectAccount
          }).close()
        }
      } else if (show) {
        // 未绑定账户or登录态失效时 提示用户绑定
        if (!this.userIsBindAccount || this.invalidSession) {
          show && this.setToastMsg("请先绑定游戏账号")
        }
      }
      // 电信币分支【因为是前置绑定，所以userIsBindAccount=true || invalidSession=false】
    },

    /**
     * 绑定账号
     * @param {} platform 账号类型 wechat|qq
     * @returns
     */
    async selectAccount(platform) {
      if (this.isPcGame) {
        let jumpUrl = getShareUrl({
          pf: url.getParam("pf"),
          hasHash: true,
          useLocationPathname: true,
          delHashParam: ["isFromShop"],
          additionalAddParams: {
            tx_buyer_id: url.getParam("tx_buyer_id"),
            tx_trace_key: url.getParam("tx_trace_key"),
            type: "inner"
          }
        })

        // 如果是端游，引导用户跳转QQ和微信购买
        if (platform == "wechat") {
          this.currentItem?.ams?.offerid &&
            getOpenlink(
              {
                offerId: this.currentItem.ams.offerid
              },
              {
                url: jumpUrl,
                match_mode: 1
              }
            )
              .then(res => {
                if (res?.info?.openlink) location.href = res?.info?.openlink
              })
              .catch(e => {
                this.reportUserAction({
                  iformat: reportDict.ERROR.SHOP_GET_OPENLINK,
                  resultInfo: e
                })
              })
        }

        if (platform == "qq") {
          mqqApi.callQQ(jumpUrl)
        }
        return
      }

      // 以下为手游逻辑
      this.$SelectAccountPrompt({
        selectAccount: this.selectAccount
      }).close()
      this.$Loading({ msg: "绑定跳转中，请稍等" })?.show()

      // 绑定前，需要先清空之前的绑定状态。
      // 原因是： 虎牙的QQ绑定登录态在业务侧，微信绑定登录态在txcz侧。如果不清空，会存在txcz和业务侧同时有绑定登录态的情况，不知道使用哪个
      let res = await this.clearBindSession()
      if (res?.ret != 0 || res?.msg != "ok") {
        this.$Loading().hide()
        this.setToastMsg("网络繁忙，请稍后再试")
        return
      }

      this.resetPageStatus()

      this.reportUserAction({
        iformat: `${reportDict.CLICK.DETAIL_OUTER_CHANGE_ACCOUNT}_${platform == "qq" ? "qq" : "wx"}`
      })

      let bindUrl = `${location.origin}${location.pathname}${location.search}#/bind`

      let addtionalParam = {
        third_openid: url.getParam("openid", bindUrl),
        third_openkey: url.getParam("openkey", bindUrl),
        third_session_id: url.getParam("sessionid", bindUrl),
        third_session_type: url.getParam("sessiontype", bindUrl),
        offerId: this.currentOfferId,
        disablePrivacy: 1,
        returnText: `返回${this.AppName}APP`,
        tx_ua: this.userAgent.ksNebula ? "ksNebula" : ""
      }
      if (this.outerIsThirdSession && this.userAgent.douyu && this.userAgent.android) {
        // 斗鱼安卓拉起小程序需要另外传参
        addtionalParam.parameter = "wechat&gameIdList=1"
      }

      bindUrl = url.addGetParam(addtionalParam, url.delParam(["openid", "openkey", "sessionid", "sessiontype", "r", "code"], bindUrl))

      // 如果在快手APP内
      if (this.outerIsThirdSession && this.userAgent.kuaishou) {
        // 微信使用小程序绑定，因为司外的微信登录态无法通过未成年人查询

        if (platform == "wechat") {
          // 因为快手拉起小程序后的代码不运行，所以提前将询问弹窗写入
          setTimeout(() => {
            this.$Loading().hide()
            this.showUserCheckIsBindPrompt()
          }, 500)
          // kuaiApi.openWechatMiniProgram 安卓内无法拉起小程序
          await yodajsApi.openWechatMiniProgram({
            path: `/webviewPage/pages/routeDistribution/routeDistribution?url=${encodeURIComponent(bindUrl)}`
          })
          return

          // import("../../api/yodasdk.js").then(() => {
          //   kuaiApi.obtainOpenId(
          //     platform,
          //     () => {
          //       this.setToastMsg("绑定成功")
          //       // 换绑后需要刷新页面，因为换绑之前请求的大区角色可能不是一个端的
          //       try {
          //         this.clearMobileZoneSelectorCache()
          //       } catch (error) {
          //         console.log(error)
          //       }
          //       location.reload()
          //     },
          //     ret => {
          //       if (ret == 0) {
          //         this.setToastMsg("取消绑定")
          //       } else {
          //         this.setToastMsg("系统繁忙，请稍后再试")
          //       }
          //     }
          //   )
          // })
        }

        if (platform == "qq") {
          // 因为QQ内返回
          setTimeout(() => {
            this.$Loading().hide()
            this.showUserCheckIsBindPrompt()
          }, 500)

          mqqApi.callQQ(bindUrl)
          return
        }
      }

      // 虎牙app内
      if (this.outerIsThirdSession && this.userAgent.huya) {
        this.$Loading().hide()

        if (platform == "wechat") {
          window.parent.postMessage(
            {
              miniprogram: 1,
              path: `/webviewPage/pages/routeDistribution/routeDistribution?url=${encodeURIComponent(bindUrl)}`,
              miniId: "gh_8c72130e300c"
            },
            "*"
          )
        }
        if (platform == "qq") {
          // window.parent.postMessage({ bindAction: 1 }, "*")
          // window.parent.postMessage({ bindAction: "qq" }, "*") // 目前QQ中使用 --- 虎牙android暂时没有渠道，也没有提供scheme，且他们并不在意andriod回跳会回到首页问题，所以统一改为使用mqqApi.callQQ
          // if (this.userAgent.iOS) {
          //   mqqApi.callQQ(bindUrl)
          // } else {
          //   window.parent.postMessage({ bindAction: "qq" }, "*")
          // }
          mqqApi.callQQ(bindUrl)
        }
      }
      // 斗鱼app内
      if (this.outerIsThirdSession && this.userAgent.douyu) {
        this.$Loading().hide()
        if (platform == "wechat") {
          window.parent.postMessage(
            {
              type: "wxmindashi",
              data: {
                userName: "gh_8c72130e300c",
                path: `/webviewPage/pages/routeDistribution/routeDistribution?url=${encodeURIComponent(bindUrl)}`
              }
            },
            "*"
          )
        }
        if (platform == "qq") {
          mqqApi.callQQ(bindUrl)
        }
      }

      setTimeout(() => {
        this.showUserCheckIsBindPrompt()
      }, 500)
    },

    // 重置页面状态
    resetPageStatus() {
      // 1. 登录态变回第三方登录态
      this.resetThirdState()
      this.userIsBindAccount = false
      // 2. 券置空 （详情页才有的方法，专区页没有）
      this.clearUserCouponInfo && this.clearUserCouponInfo()
      // 3. cache里的区服信息清空（clearUserZoneRoleCache里处理了）
      // 换绑后需要刷新页面，因为换绑之前请求的大区角色可能不是一个端的
      this.clearUserZoneRoleCache({ offerId: this.currentOfferId })
      // 4. 重新初始化大区组件，否则换绑后回到页面parseCachedZoneRole还是上次的结果
      this.newZoneAndRoleSelector({
        useCmallQuery: this.checkThirdSession,
        thirdOfferId: this.checkThirdSession && url.getParam("biz_appid") ? url.getParam("biz_appid") : ""
      })
      // 5. 重置用户余额（点券金币）
      this.clearGameCoinBalance && this.clearGameCoinBalance()
    },

    /**
     * 询问用户是否绑定的弹窗
     */
    showUserCheckIsBindPrompt() {
      this.$SelectAccountPrompt({
        selectAccount: this.selectAccount
      }).close()
      this.promptInstance = this.$PromptControl({
        msgText: "请确认是否已绑定",
        confirmText: "已绑定",
        cancelText: "未绑定",
        onConfirm: () => {
          location.reload()
          // 刷新状态
          // this.queryThirdSessionBindSession(true)
          this.promptInstance.hide()
        },
        onCancel: () => {
          // 用户点击未绑定，也刷新一下登录态，以防用户绑定了点击未绑定
          this.queryThirdSessionBindSession(true)
          this.promptInstance.hide()
          this.$SelectAccountPrompt({
            selectAccount: this.selectAccount
          }).show()
        }
      })

      this.promptInstance?.show()
      this.reportUserAction({ iformat: reportDict.PAGE_VIEW.BIND_BEORNOT_POPUPS })
    },

    clearBindSession() {
      let cmallQueryObj = this.initCmallQueryObj()
      return cmallQueryObj.clearBindAccount()
    },

    /**
     * 查询第三方登录态绑定的QQ/WX登录态 || 查询完毕后重新设置账号类型再查大区 && 查询预售兑换券
     */
    async queryThirdSessionBindSession(secondBind = false, fn) {
      let bindUserInfo = {}
      let zoneId = null
      if (this.isPcGame) {
        this.userIsBindAccount = false
        // 如果是端游，则默认为没有绑定，因为端游查大区查角色接口暂不支持第三方登录态，需要引导用户跳转到QQ和微信里参与
        return
      }
      // 如果是第三方登录态需要先调用一次查大区，确认用户是否绑定 || 如果有平台币道具直购offerid，需要用平台币道具直购offerid查绑定
      let cmallQueryObj = this.initCmallQueryObj()
      let res = await cmallQueryObj.queryBindAccount()

      // 比如电信币这种平台币购买，前置绑定，使用的是业务绑定微信登录态。
      if (res && res.user_id && res?.user_id_type == "wechatid" && res?.appid != WX_APPID && !url.getParam("biz_appid")) {
        // 如果返回的绑定登录态是业务的微信登录态，则认为是无效的，用户没有绑定，提示用户重新绑定
        this.userIsBindAccount = false
        if (secondBind) {
          this.setToastMsg("绑定失败，请重新选择账号绑定~")
        }
        return
      }

      if (res && res.user_id && res?.user_id_type == "uin" && res?.appid == "100228415") {
        // 如果返回的绑定登录态是快手的QQ登录态，则认为是无效的，用户没有绑定，提示用户重新绑定 || 因为快手QQ也走腾讯充值绑定
        this.userIsBindAccount = false
        if (secondBind) {
          this.setToastMsg("绑定失败，请重新选择账号绑定~")
        }
        return
      }

      if (res && res.user_id && res.user_id_type && res?.token_valid === "1") {
        this.userIsBindAccount = true
        this.setZoneSelectorZoneInfo({
          bind_user_id: res.user_id,
          bind_user_type: res.user_id_type
        })
        // 不在查绑定的接口设置登录态，是因为此时的登录态可能是失效的，大区组件登录态失效的报错不暴露，无法通过错误码来控制交互
        // 第三方登录态需要重新设置provideAccountType
        if (res.user_id_type == "wechatid") this.setProvideAccountType(enums.ACCOUNT_TYPE.WX)
        if (res.user_id_type == "uin") this.setProvideAccountType(enums.ACCOUNT_TYPE.QQ)

        bindUserInfo = {
          bind_ori_user_id: res.ori_user_id,
          bind_user_access_token: res.access_token,
          bind_user_type: res.user_id_type,
          bind_user_id: res.user_id,
          bind_user_appid: res.appid,
          bind_user_session_id: res.session_id,
          bing_user_session_type: res.session_type
        }

        // 不是所有第三方登录态查到绑定登录态都要替换登录号。
        // 比如电信币这种平台币购买，依旧使用第三方登录态作为登录号，绑定账号作为承载号传给下单，做实名制认证判断
        if (
          bindUserInfo.bind_ori_user_id &&
          bindUserInfo.bind_user_access_token &&
          bindUserInfo.bind_user_type &&
          !url.getParam("biz_appid")
        ) {
          await this.setLoginStateThirdSence(bindUserInfo)
          fn?.()
        }

        // 手游初始化大区组件。
        if (this.isMobileGame) {
          this.newZoneAndRoleSelector({
            useCmallQuery: this.checkThirdSession,
            // 当前是第三方登录态 && 地址里有平台币道具直购offerid，需要使用平台币道具直购offerid查大区角色，平台币道具直购offerid下挂了对应的第三方登录态回调。同时平台币道具直购offerid会配置游戏点券的大区映射
            // 因为每个offerid只能挂载一个第三方登录态回调，9044已经挂载了快手，所以其他平台币挂载在平台币道具直购offerid下。
            thirdOfferId: this.checkThirdSession && url.getParam("biz_appid") ? url.getParam("biz_appid") : ""
          })
        }

        let accountId = this.getAccountId()
        if (this.$route.path.indexOf("order") > -1) {
          await this.getZoneInfo(accountId)
            .then(userZoneInfo => {
              zoneId = userZoneInfo?.zone_id
            })
            .catch(() => {
              this.userIsBindAccount = false
            })
        } else {
          // 详情页——取默认大区，查询预售相关逻辑
          await this.getZoneInfo(accountId)
            .then(userZoneInfo => {
              zoneId = userZoneInfo?.zoneId
              this.checkProOrderLocalRecord(userZoneInfo)
              // 第三方登录态支持查兑换券 => 由于第三方登录态的绑定关系迁移到了腾讯充值侧，之前的查询逻辑是查的业务绑定，这里需要用绑定登录态来查询
              this.queryUserBuyedPreOrder({
                use_bind_id: 1
              })
            })
            .catch(() => {
              this.userIsBindAccount = false
            })
        }
        try {
          // 已绑定，且没有缓存大区和推荐大区角色（即getZoneInfo取出来的zoneid是空的），登录态没有失效
          if (this.checkUserIsBindAccount && !this.invalidSession && !zoneId && this.isStraightUrl) {
            if (this.$route.path.indexOf("order") > -1) {
              this.chooseZone()
            } else {
              this.openZoneAndRoleSelector()
            }
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.userIsBindAccount = false
        if (res?.token_valid !== "1") this.updateInvalidSession(true)
        if (secondBind) {
          this.setToastMsg("绑定失败，请重新选择账号绑定~")
        }
      }

      return bindUserInfo
    },

    // 第三方登录态场景设置绑定的QQ/WX登录态
    async setLoginStateThirdSence(bindUserInfo) {
      this.updateInvalidSession(false)
      let uinSkey = bindUserInfo.bind_ori_user_id == bindUserInfo.bind_user_id && !bindUserInfo.bind_user_appid
      let loginState = {
        openid: bindUserInfo.bind_ori_user_id,
        openkey: bindUserInfo.bind_user_access_token,
        sessionId:
          bindUserInfo.bind_user_session_id || (bindUserInfo.bind_user_type == "wechatid" ? "hy_gameid" : uinSkey ? "uin" : "openid"),
        sessionType:
          bindUserInfo.bing_user_session_type ||
          (bindUserInfo.bind_user_type == "wechatid" ? "wc_actoken" : uinSkey ? "pskey_307" : "kp_accesstoken"),
        wxAppid2: bindUserInfo.bind_user_type == "wechatid" ? bindUserInfo.bind_user_afppid : "",
        qqAppid: bindUserInfo.bind_user_type == "uin" ? bindUserInfo.bind_user_appid : ""
      }
      this.setLoginState(loginState)
      try {
        await setUserPrivacy({
          sandbox: this.sandbox,
          offerId: this.currentOfferId,
          loginState: loginState
        })
      } catch (error) {
        console.log("setUserPrivacy error")
      }
    },

    // 重置第三方登录态
    resetThirdState() {
      if (this.checkThirdSession) return

      this.setLoginState({
        ...this.thirdLoginState
      })
    }
  }
}
